import React from 'react';
import PropTypes from 'prop-types';

import ProductPropertyTab, { PropertyList } from '../../molecules/product-detail-accordion';

const DETAIL_PROPERTIES = [
  'Maisonette Product ID',
  'Assembly Required',
  'Made to Order',
  'Country of Origin'
];

const Details = (props) => {
  if (!props.product) return null;

  const getProductDetails = () => {
    const properties = props.product?.product_properties;

    if (!!properties === false) return { id: 0, name: 0, value: 0 };

    const propObject = (value, name, id) => ({
      id,
      name,
      value
    });

    const detailsArray = properties.filter(
      (property) => DETAIL_PROPERTIES.includes(property.property_name)
    ).map((property) => {
      if (property.property_name === DETAIL_PROPERTIES[0]) {
        return propObject(`Item number ${property.value}`, property.property_name, property.id);
      }

      if (
        (
          property.property_name === DETAIL_PROPERTIES[1]
          || property.property_name === DETAIL_PROPERTIES[2]
        )
        && property.value.toLowerCase() === 'yes') {
        return propObject(property.property_name, property.property_name, property.id);
      }

      if (property.property_name === DETAIL_PROPERTIES[2] && property.property_name.toLowerCase() === 'yes') {
        return propObject(property.property_name, property.property_name, property.id);
      }

      if (property.property_name === DETAIL_PROPERTIES[3]) {
        return property.value.toLowerCase().includes('handmade')
          ? propObject(property.value, property.property_name, property.id)
          : propObject(property.value, property.property_name, property.id);
      }

      return propObject(property.value, property.property_name, property.id);
    });

    if (props.variant) {
      const { variant } = props;

      if (parseFloat(variant.weight)) {
        detailsArray.push(propObject(variant.weight, 'Weight', 'weight'));
      }

      if (parseFloat(variant.height)) {
        detailsArray.push(propObject(variant.height, 'Height', 'height'));
      }

      if (parseFloat(variant.width)) {
        detailsArray.push(propObject(variant.width, 'Width', 'width'));
      }

      if (parseFloat(variant.depth)) {
        detailsArray.push(propObject(variant.depth, 'Depth', 'depth'));
      }
    }

    return detailsArray.filter((item) => item.value !== 'No');
  };

  const details = getProductDetails();

  if (!details || details.length === 0 || typeof details.map !== 'function') return null;

  return (
    <ProductPropertyTab title="Details">
      <PropertyList element="ul" like="paragraph-2">
        {
          details.map((item) => (
            <li key={item.id}>{`${item.name}: ${item.value}`}</li>
          ))
        }
      </PropertyList>
    </ProductPropertyTab>
  );
};

Details.defaultProps = {
  variant: null
};

Details.propTypes = {
  variant: PropTypes.object,
  product: PropTypes.object.isRequired
};

export default Details;
